export default __webpack_public_path__ + "static/media/Girls_0.763ed162.svg";